export default __webpack_public_path__ + "static/popup-7b61d4fef7ca5378f5283464249cb956.png";